import type { FaireProductEntity } from "../../entity_types/product";

export const p_8m6rvdrqg7: FaireProductEntity = {
  token: "p_8m6rvdrqg7",
  type: "product",
  name: "Mother Bracelet",
  brandToken: "b_89eiwaa62p",
  brandName: "JILZARAH",
  imageUrl:
    "https://cdn.faire.com/fastly/015b4ec1a4ba87d35aa3c55105d9b1aa6946c2ab1167e86d1aeb9cb149a1f57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb211ce9f47003cdbb6e27f18fe2c3a26f461be78b8c1806df41f7917383de3e.jpeg",
    "https://cdn.faire.com/fastly/80f74ea31b0fc9a977860bf3f67a6052526c30843c84eb942327ea10ddebdcca.jpeg",
    "https://cdn.faire.com/fastly/77729bb68bfbfa1fdd17000e6bdf2117f9b05cb8dda14759259db307a541e790.jpeg",
    "https://cdn.faire.com/fastly/421df9ca84f35047fec24daddd549f733bff8363bdf78441053c9e422f7ea4f6.jpeg",
    "https://cdn.faire.com/fastly/8718f01ee0a349cd826a4d53ffdb5dbd0d39b648d12f7026275a30ab7c97f91f.jpeg",
    "https://cdn.faire.com/fastly/5057230d5f487f704112aea7ba6cf66a807aab355dfd383e4adb3795142533f1.jpeg",
    "https://cdn.faire.com/fastly/aaacb348124e208b2122c6dce2180dbd799ffd39a66bc48f2c6feeb8e8665380.jpeg",
    "https://cdn.faire.com/fastly/9315efe99cdb2e4e4c56b91d609ba065994da67afa4bdb5df42b190df02d7982.jpeg",
  ],
  priceDollars: 17.12,
  description:
    "The perfect gift to let your Mother know how special she is to you!\n\n\n\nThis bracelet is a demonstration of gratitude for the recipient. Thoughtful detail leads to heartfelt messaging from the packaging to the product and keepsake insert card. Truly, a special gift.\n\nAdditional Details:\n\n * Handcrafted 8mm polymer clay beads and a unique charm on a durable 1.2mm elastic cord \n * Antique-finish silver spacers \n * Lead-free, nickel-free, and cadmium-free, fastened to a display-ready header card \n * Elastic Stretch Style \n * One size fits most \nSold in Multiples of: 2",
  tags: [],
  msrpDollars: 38.35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:39.676Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
